import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ResizableDirective} from './resizable.directive';
import {ResizableHandleDirective} from './resizable-handle.directive';
import {ResizableService} from '@shared/resizable/resizable.service';

@NgModule({
  declarations: [
    ResizableDirective,
    ResizableHandleDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ResizableDirective,
    ResizableHandleDirective
  ]
})
export class ResizableModule {
  static forRoot(): ModuleWithProviders<ResizableModule> {
    return {
      ngModule: ResizableModule,
      providers: [ ResizableService ]
    }
  }
}
